import { render } from "./techniques.vue?vue&type=template&id=dcb2baf0"
import script from "./techniques.vue?vue&type=script&lang=js"
export * from "./techniques.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__